import React, { useRef } from "react";

import Button from "@/components/Atoms/Button";
import Slider from "@/components/Atoms/Slider";

import SlickArrowButton from "@/components/Molecules/SlickArrowButton";

import BootcampCard from "./BootcampCard";

import { classNameGenerator } from "@/utils";

import styles from "./BootcampCarousel.module.scss";

interface BootcampCarouselProps {
  bootcamps: {
    href: string;
    title: string;
    description: string;
    thumbnail: string;
    tags: string[];
    packData: {
      duration: string;
      currencySymbol: string;
      price: string;
      startDate: string;
    };
  }[];
}

const BootcampCarousel: React.FC<BootcampCarouselProps> = ({ bootcamps }) => {
  const sliderRef = useRef(null);

  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
    prevArrow: (
      <SlickArrowButton
        buttonType="prev"
        variant="icon1"
        icon="icon-testimonials-previous"
      />
    ),
    nextArrow: (
      <SlickArrowButton
        buttonType="next"
        variant="icon1"
        icon="icon-testimonials-next"
      />
    ),
  };

  const next = () => {
    sliderRef.current.slickNext();
  };

  const previous = () => {
    sliderRef.current.slickPrev();
  };

  const cls = classNameGenerator(styles);

  const actionButtons = (
    <div className={cls("actionButtons")}>
      <Button
        variant="icon"
        icon="icon-testimonials-previous"
        onClick={previous}
      />
      <Button variant="icon" icon="icon-testimonials-next" onClick={next} />
    </div>
  );

  return (
    <section className={cls("bootcampCarousel")}>
      <div className={cls("container")}>
        <Slider ref={sliderRef} settings={settings}>
          {bootcamps?.map((bootcamp, index) => (
            <BootcampCard key={index} {...bootcamp} />
          ))}
        </Slider>
        {actionButtons}
      </div>
    </section>
  );
};

export default BootcampCarousel;
